export default __webpack_public_path__ + "static/coming-soon-ef8cbf21233c30a58bb8ca80fb56371c.jpg";